@if (actionButtons && actionButtons.length > 0) {
  <div class='search-filter-action-buttons-mobile mr-8 pr-8'>
    @for (customAction of actionButtons; track indexTrackBy($index, customAction)) {
      <button
        mat-flat-button
        class='mr-4'
        [matTooltip]='customAction.tooltip'
        [color]='customAction.buttonColor'
        (click)='customAction.onClick($event, null, dataContainerService, datasetNavigatorService)'>
        @if (customAction.buttonIcon) {
          <mat-icon>{{customAction.buttonIcon}}</mat-icon>
        }
        @if (customAction.buttonText) {
          <span [class.ml-4]='customAction.buttonIcon'>{{customAction.buttonText | translate}}</span>
        }
      </button>
    }
  </div>
}
@if ((actionButtons && actionButtons.length > 0) || showSearchText || formConfig) {
  <div class="search-filter-box fx-row fx-justify-start fx-items-center">
    @if (actionButtons && actionButtons.length > 0) {
      <div class='search-filter-action-buttons mr-8 pr-8'>
        @for (customAction of actionButtons; track indexTrackBy($index, customAction)) {
          <button
            mat-flat-button
            class='mr-4'
            [matTooltip]='customAction.tooltip'
            [color]='customAction.buttonColor'
            (click)='customAction.onClick($event, null, dataContainerService, datasetNavigatorService)'>
            @if (customAction.buttonIcon) {
              <mat-icon>{{customAction.buttonIcon}}</mat-icon>
            }
            @if (customAction.buttonText) {
              <span [class.ml-4]='customAction.buttonIcon'>{{customAction.buttonText | translate}}</span>
            }
          </button>
        }
      </div>
    }
    @if (showSearchText) {
      <mat-icon>search</mat-icon>
      <input type='text' [placeholder]="'Cerca' | translate" (keydown.enter)='applyFilter(null)' autocomplete="off" [formControl]='defaultSearchControl' class="fx-flex"/>
      @if (!formConfig && defaultSearchControl.value) {
        <mat-icon style='cursor: pointer;' (click)='defaultSearchControl.setValue(""); applyFilter();' matTooltip='Pulisci filtro'>close</mat-icon>
      }
    }
    @if (!showSearchText) {
      <div class="fx-flex"></div>
    }
    <!--<mat-form-field  class='mr-4' appearance="outline" [floatLabel]='"never"'>
    <mat-icon matPrefix class='mr-4'>search</mat-icon>
    <input matInput type='text' placeholder="Cerca" (keydown.enter)='applyFilter()' autocomplete="off" [formControl]='defaultSearchControl'>
  </mat-form-field>-->
  @if (formConfig) {
    <div class='extra-filters'>
      <button (click)='openFilters()' [ngClass]='filterCount ? "active-filters" : ""' mat-flat-button color='primary'>
        <span>{{'Filtri' | translate}}</span>
        @if (filterCount) {
          <span class='ml-4 filter-count'>{{filterCount}}</span>
        }
      </button>
      @if (filterCount) {
        <button mat-icon-button [matTooltip]='"Pulisci filtri" | translate' (click)='clearFilters()'>
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }
</div>
}